import { EEthereumNetworkId } from '@ankr.com/provider';
import BigNumber from 'bignumber.js';

import { ApiTaskExecution, AutomateApi } from 'modules/api';
import { api, cacheTags } from 'modules/store';

interface GetTaskExecutionsItem extends ApiTaskExecution {
  isSuccess: boolean;
  cost: BigNumber;
  usdCost: BigNumber | null;
}

export type GetTaskExecutionsResult = GetTaskExecutionsItem[];

export const {
  useGetExecutionsQuery,
  endpoints: { getExecutions },
} = api.injectEndpoints({
  endpoints: build => ({
    getExecutions: build.query<
      GetTaskExecutionsResult,
      {
        taskId: string;
        chainId: EEthereumNetworkId | null;
        usdPrice: BigNumber;
      }
    >({
      queryFn: async ({ taskId, chainId, usdPrice }) => {
        if (!taskId || !chainId) {
          return { data: [] };
        }

        const api = new AutomateApi(chainId);
        const executions = await api.getTaskExecutions(taskId);

        const result: GetTaskExecutionsResult = executions.map(execution => {
          const { payment, success } = execution;

          return {
            ...execution,
            isSuccess: success,
            cost: payment,
            usdCost: usdPrice?.multipliedBy(payment) ?? null,
          };
        });

        return {
          data: result,
        };
      },
      providesTags: [cacheTags.taskData],
    }),
  }),
});
